import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { UnitTweleveExcelDataEntity } from "../dto/unit-twelve-excel.entity";


@Injectable()
export class UnitTweleveExcelRepo extends Repository<UnitTweleveExcelDataEntity> {

    constructor(@InjectRepository(UnitTweleveExcelDataEntity) private unittweleveexcelRepo: Repository<UnitTweleveExcelDataEntity>
    ) {
        super(unittweleveexcelRepo.target, unittweleveexcelRepo.manager, unittweleveexcelRepo.queryRunner);
    }

}